export default "__VITE_PUBLIC_ASSET__4fbb8e87__"